import React from 'react';

import { TableColumnDef } from '../../utils/tableColumns';
import { SortDir } from '../../utils/tableSort';
import SortBy from '.';

/**
 * Header cells for the currently-visible columns: a `SortBy` control where the endpoint can sort
 * that column, plain text everywhere else. Shared by every customizable list so a column becomes
 * sortable by declaring `sortField` in its config and nothing else.
 *
 * `defaultDirFor` gives the direction a first click opens on; without it every column opens
 * newest-first, which suits a list whose sortable columns are all dates.
 */
const buildHeaderColumns = <Id extends string, Field extends string>(
    columns: TableColumnDef<Id, Field>[],
    isVisible: (id: Id) => boolean,
    defaultDirFor?: (field: Field) => SortDir
): React.ReactNode[] =>
    columns
        .filter((column) => isVisible(column.id))
        .map((column) => {
            if (column.sortField) {
                return (
                    <SortBy
                        key={column.id}
                        field={column.sortField}
                        label={column.label}
                        defaultDir={defaultDirFor?.(column.sortField)}
                        centered={column.centered}
                    />
                );
            }

            return column.centered ? (
                <div key={column.id} className="align-center">
                    {column.label}
                </div>
            ) : (
                column.label
            );
        });

export default buildHeaderColumns;
